import { render } from "./Section10.vue?vue&type=template&id=1a979205&scoped=true"
import script from "./Section10.vue?vue&type=script&lang=js"
export * from "./Section10.vue?vue&type=script&lang=js"

import "./Section10.vue?vue&type=style&index=0&id=1a979205&lang=scss&scoped=true"
import "./Section10.vue?vue&type=style&index=1&id=1a979205&lang=scss&scoped=true"
import "./Section10.vue?vue&type=style&index=2&id=1a979205&lang=css"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a979205"]])

export default __exports__